import { Button, Typography } from "@mui/material";
import React from "react";

const PricingHeadline = ({ onChange, value, loading, handleSubmit }) => {
  return (
    <div style={{ display: "block" }}>
      <Typography sx={{ marginTop: "10px", fontSize: "14px" }} variant="paragraph">
        Configure the main headline that will appear on your pricing page
      </Typography>
      <div style={{ width: "100%", marginTop: "10px" }}>
        <input
          type="text"
          placeholder="Add in header here"
          value={value}
          onChange={onChange}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "10px",
            border: "1px solid #ccc",
            fontSize: "16px",
            outline: "none",
          }}
        />
      </div>
      <div
        style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px", width: "100%" }}
      >
        <Button
          onClick={handleSubmit}
          disabled={!value || loading}
          variant="contained"
          color="primary"
          sx={{ marginTop: "10px" }}
        >
          save
        </Button>
      </div>
    </div>
  );
};

export default PricingHeadline;
